import React, { useState } from "react";
import {
    Box,
    Card,
    Typography,
    Radio,
    Divider,
    Avatar,
    Button,
    Switch,
} from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Header from "../components/header.tsx";
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EastIcon from '@mui/icons-material/East';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import StarRating from "../components/star_ratings.tsx";
import SecurityIcon from '@mui/icons-material/Security';
import GppGoodIcon from '@mui/icons-material/GppGood';
import Footer from "../components/footer.tsx";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Dropbox } from '../assets/svg/dropbox.svg';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { ReactComponent as OrderPackage } from '../assets/svg/packed_cardboard.svg';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useTheme, useMediaQuery } from '@mui/material';


const initialItems = [
    {
        id: 1,
        name: 'Tablet',
        price: 49.99,
        oldPrice: 59.99,
        quantity: 2,
        image: deals_1,
        availability: 'In Stock',
        rating: 4
    },
    {
        id: 2,
        name: 'Wireless Headphone',
        price: 29.99,
        oldPrice: 49.99,
        quantity: 1,
        image: deals_2,
        availability: 'In Stock',
        rating: 3.5
    },
];

const ViewOrder = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [items, setItems] = useState(initialItems);
    const navigate = useNavigate();

    const orderStatus = [
        {
            label: 'Ordered',
            date: '15 June 2025',
            icon: <ShoppingCartIcon />,
            // description: 'Return request submitted',
            completed: true,
        },
        {
            label: 'Order Ready',
            date: '17 June 2025',
            icon: <Dropbox />,
            // description: 'Your return request has been approved',
            completed: true,
        },
        {
            label: 'Shipped',
            date: '19 June 2025',
            icon: <LocalShippingIcon />,
            // description: 'We have received your return package',
            completed: true,
        },
        {
            label: 'Out for delivery',
            date: '20 June 2025',
            icon: <TimelapseIcon />,
            // description: 'Refund of AED69.98 has been processed to your original payment method',
            completed: true,
        },
        {
            label: 'Delivered',
            date: '22 June 2025',
            icon: <OrderPackage />,
            // description: '',
            completed: false,
        },
    ];

    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* order confirmation body section */}
            <Box sx={{ padding: '3%' }}>
                <Typography><b>Order ID:</b> ORD-184567</Typography>
                <Typography sx={{ color: 'gray', mb: 2 }}>{`Home > My Account > My Orders > Track/View Order`}</Typography>
                {/* top section (tracking order) */}
                <Box p={2} bgcolor="#f9f9f9">
                    <Typography sx={{ fontWeight: 'bold', color: 'gray', mb: 1 }}>Track Order</Typography>
                    <Card sx={{ p: 4 }}>
                        {!isMobile && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    width: '100%',
                                }}
                            >
                                {orderStatus.map((step, index) => {
                                    const nextStep = orderStatus[index + 1];
                                    const showLine =
                                        step.completed && nextStep && nextStep.completed;

                                    return (
                                        <Box
                                            key={index}
                                            sx={{
                                                position: 'relative',
                                                flex: 1,
                                                textAlign: 'center',
                                                minWidth: 100,
                                            }}
                                        >
                                            {/* Step Icon */}
                                            <Box sx={{ position: 'relative', zIndex: 2 }}>
                                                {step.completed ? (
                                                    <CheckCircleIcon sx={{ color: '#c62828', fontSize: 32 }} />
                                                ) : (
                                                    <RadioButtonUncheckedIcon sx={{ color: '#c62828', fontSize: 32 }} />
                                                )}
                                            </Box>

                                            {/* Label & Date */}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: '2px',
                                                    mt: 1,
                                                }}
                                            >
                                                {step.icon}
                                                <Typography fontWeight={600}>{step.label}</Typography>
                                            </Box>
                                            <Typography variant="caption">{step.date}</Typography>

                                            {/* Line connecting to the next step (behind icon) */}
                                            {showLine && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '16px', // middle of 32px icon
                                                        left: '53%',
                                                        width: '90%',
                                                        height: '2px',
                                                        backgroundColor: '#c62828',
                                                        zIndex: 1,
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    );
                                })}
                            </Box>
                        )}

                        {isMobile && (
                            <Box>
                                {orderStatus.map((step, index) => (
                                    <Box
                                        key={index}
                                        sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', position: 'relative' }}
                                    >
                                        {/* Icon + Vertical Line */}
                                        <Box sx={{ position: 'relative', pr: 1 }}>
                                            <Box sx={{ zIndex: 1, position: 'relative' }}>
                                                {step.completed ? (
                                                    <CheckCircleIcon sx={{ color: '#c62828' }} fontSize="small" />
                                                ) : (
                                                    <RadioButtonUncheckedIcon sx={{ color: '#c62828' }} fontSize="small" />
                                                )}
                                            </Box>

                                            {/* Vertical Line */}
                                            {index < orderStatus.length - 1 && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 20,
                                                        left: '38%',
                                                        transform: 'translateX(-50%)',
                                                        width: '2px',
                                                        height: '50px',
                                                        backgroundColor: '#c62828',
                                                        zIndex: 0,
                                                    }}
                                                />
                                            )}
                                        </Box>

                                        {/* Text */}
                                        <Box pb={index < orderStatus.length - 1 ? 3 : 0}>
                                            <Typography
                                                fontWeight={600}
                                                sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                                            >
                                                {step.icon}
                                                {step.label}
                                            </Typography>
                                            <Typography variant="caption" display="block" gutterBottom>
                                                {step.date}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </Card>
                </Box>
                {/* end top section */}

                {/* bottom section(delivery address, order summary and pricing details) */}
                <Box
                    minHeight="100vh"
                    display="flex"
                    flexDirection={{ xs: "column", md: "row" }}
                    alignItems={{ xs: "stretch", md: "flex-start" }}
                    justifyContent="center"
                    bgcolor="#f9f9f9"
                    p={2}
                    gap={3}
                >

                    <Box width={{ xs: "100%", md: "65%" }}>
                        {/* left side card */}
                        <Card sx={{ p: 4, borderRadius: 3, /* maxWidth: 600, */ /* width: "100%"  */ }}>

                            {/* Delivery address */}
                            <Box>
                                <Typography sx={{ fontWeight: 'bold', color: 'gray', mb: 1 }}>Delivery Address</Typography>
                                <Card
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        borderRadius: 2,
                                    }}
                                >
                                    <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                                        <Typography fontWeight="bold">John Doe</Typography>
                                        {/* <Button sx={{ color: '#d32f2f', background: '#ffe5e5', textTransform: 'none' }}>Default</Button> */}
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" color="text.secondary" width={"28%"}>
                                            Villa 25, Street 12B,
                                            Al Barsha 2 Near Al Barsha Mall Dubai,
                                            United Arab Emirates<br />
                                            ph.no: 123 456 7890
                                        </Typography>
                                    </Box>
                                </Card>
                            </Box>

                            {/* Payment Metod */}
                            {/* <Box>
                            <Typography sx={{ fontWeight: 'bold', color: 'gray', mb: 1, display: 'flex', justifyContent: 'space-between' }}><span>Payment Method</span><span style={{ fontWeight: 'lighter', color: '#C32032' }}>Change</span></Typography>
                            <Card
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    borderRadius: 2,
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1}>
                                    <PhoneAndroidOutlinedIcon sx={{ color: '#C32032' }} />
                                    <Box>
                                        <Typography fontWeight="bold">UPI</Typography>
                                        <Box display={"flex"} alignItems={"center"}>
                                            <Typography variant="body2" color="green">
                                                <LockOutlinedIcon sx={{ fontSize: '18px' }} />
                                            </Typography>
                                            <Typography variant="body2" color="green">Secure Payment</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Card>
                        </Box> */}

                            {/* Order Summary */}
                            <Box>
                                <Typography sx={{ fontWeight: 'bold', color: 'gray', mb: 1, display: 'flex', justifyContent: 'space-between' }}><span>Order Summary</span><span style={{ fontWeight: 'lighter' }}>2 Items</span></Typography>
                                {items.map((item) => (
                                    <Card
                                        key={item.id}
                                        sx={{
                                            display: 'flex',
                                            mb: 2,
                                            p: 2,
                                            borderRadius: 2,
                                            boxShadow: 2,
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={item.image}
                                            alt={item.name}
                                            sx={{
                                                width: 80,
                                                height: 80,
                                                objectFit: 'cover',
                                                borderRadius: 1,
                                                mr: 2,
                                            }}
                                        />
                                        <Box flex={1}>
                                            <Typography fontWeight="bold">{item.name}</Typography>
                                            <StarRating rating={item.rating} />
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032', display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                <span>AED{item.price}</span>
                                                <span style={{ textDecoration: 'line-through', color: '#888', fontSize: '14px' }}>AED{item.oldPrice}</span>
                                                <span style={{ color: 'green', fontSize: '12px' }}>You save: AED30.00</span>
                                            </Typography>
                                            <Typography fontSize={"14px"}><span>Qty: 2</span></Typography>
                                            <Typography fontSize={"14px"} display={"flex"} alignItems={"center"} gap={1} color="gray"><LocalShippingIcon />Estimated Delivery: Tuesday, Jul 24</Typography>
                                        </Box>
                                    </Card>
                                ))}
                            </Box>
                        </Card>
                    </Box>

                    <Box width={{ xs: "100%", md: "35%" }}>
                        {/* right side card */}
                        <Card sx={{ p: 4, borderRadius: 3, height: '608px'/* maxWidth: 600, */ /* width: "100%" */ }}>
                            {/* Price Details */}
                            <Box>
                                <Typography sx={{ fontWeight: 'bold', color: 'gray', mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span>Price Details</span><span style={{ fontWeight: 'lighter', color: 'green', background: '#D1FFBD', padding: 10, borderRadius: '24px', fontSize: '12px' }}>You Save AED155.00</span></Typography>
                                <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography>Items ({items.length})</Typography>
                                        <Typography sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ textDecoration: 'line-through', color: 'gray', textAlign: 'right' }}>AED639.9</span>
                                            AED{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography>Product Discount</Typography>
                                        <Typography color={"green"}>
                                            AED-140.00
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography>Coupon Applied <span style={{ background: '#D1FFBD', color: 'green', borderRadius: '6px', padding: 8, fontSize: '12px' }}>WELCOME25</span></Typography>
                                        <Typography color={"green"}>
                                            AED-15.00
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography>Delivery</Typography>
                                        <Typography>
                                            AED9.99
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography fontSize={18} fontWeight="bold">Total Amount</Typography>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                                            AED{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography fontSize={14} color={"green"} sx={{ background: '#D1FFBD', padding: 1, borderRadius: '5px' }}>Your total savings on this order: AED155.00</Typography>
                                    </Box>
                                </Card>
                            </Box>

                            {/* note */}
                            <Card
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    borderRadius: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 2,
                                    mt: 3
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1}>
                                    <LocalShippingIcon sx={{ color: 'gray' }} />
                                    <Typography sx={{ color: 'gray' }}>Free returns within 30 days</Typography>
                                </Box>
                                <Divider />
                                <Box display="flex" alignItems="center" gap={1}>
                                    <GppGoodIcon sx={{ color: 'gray' }} />
                                    <Typography sx={{ color: 'gray' }}>Genuine products guaranteed</Typography>
                                </Box>
                            </Card>

                            {/* Continue Button */}
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    mt: 2,
                                    backgroundColor: "#C32032",
                                    "&:hover": { backgroundColor: "#a71a28" },
                                    display: 'flex',
                                    gap: 1,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    justifyContent: 'space-between',
                                    height: '60px'
                                }}
                                onClick={() => navigate('/')}
                            >
                                Continue Shopping
                            </Button>
                        </Card>
                    </Box>

                </Box>
                {/* end bottom section */}
            </Box>

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}


export default ViewOrder;